import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

// Sentry — no-op when VITE_SENTRY_DSN is unset (local dev)
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development',
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    ignoreErrors: ['Network Error', 'Request failed with status code 401'],
    beforeSend(event) {
      if (event.request?.headers) {
        delete event.request.headers.authorization;
        delete event.request.headers.Authorization;
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 40, textAlign: 'center', color: '#e4e8f0', background: '#080a0f', minHeight: '100vh', fontFamily: 'sans-serif' }}><h1>Something went wrong</h1><p>Please reload the page.</p></div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
